/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Subtract_Frame_From_EndInputs */

const en_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract 1 Frame From End`)
};

const fr_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustraire 1 image a la fin`)
};

const de_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe 1 Frame vom Ende ab`)
};

const it_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrai 1 fotogramma dalla fine`)
};

const ru_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычтите 1 кадр из конца`)
};

const es_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restar 1 cuadro del final`)
};

const zh_cn2_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从末尾减去 1 帧`)
};

const ja_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後から1フレーム減算`)
};

const hi_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंत से 1 फ्रेम घटाएँ`)
};

const pt_pt2_shortcut_keys_name_subtract_frame_from_end = /** @type {(inputs: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia 1 quadro do final.`)
};

/**
* | output |
* | --- |
* | "Subtract 1 Frame From End" |
*
* @param {Shortcut_Keys_Name_Subtract_Frame_From_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_subtract_frame_from_end = /** @type {((inputs?: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Subtract_Frame_From_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "de") return de_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "it") return it_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "es") return es_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_subtract_frame_from_end(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_subtract_frame_from_end(inputs)
	return en_shortcut_keys_name_subtract_frame_from_end(inputs)
});